<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12"> Non autorizzato 4 </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Notfound4',
}
</script>
